import { jsx as _jsx } from "react/jsx-runtime";
export const SvgCaretEdgeRight = (props) => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlSpace: 'preserve', viewBox: '0 0 24 24', ...props, children: _jsx("path", { d: 'm8.5 16.5 4-4.5-4-4.5m7.5 0v9' }) }));
//# sourceMappingURL=caret-edge-right.js.map